import React, { useState } from 'react';
import Footer from '../../components/mysimpledbnotes/Footer';
import './ContactUs.css';

const CONTACT_EMAIL = 'contact@mysimpledbnotes.com';
const SUPPORT_EMAIL = 'support@mysimpledbnotes.com';

export default function ContactUs() {
  const [topic,setTopic]=useState('General Question');
  const [message,setMessage]=useState('');
  const handleEmail=()=>{
    const subject=encodeURIComponent(`MySimpleDB Notes - ${topic}`);
    const body=encodeURIComponent(message||'');
    window.location.href=`mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
  };
  return <div className="product-public-page">
    <main className="product-public-main">
      <section className="product-public-hero">
        <div className="product-public-eyebrow">MySimpleDB Notes</div>
        <h1>Contact Us</h1>
        <p>Have a question about MySimpleDB Notes? We would be happy to hear from you.</p>
      </section>
      <section className="product-card contact-grid">
        <div><h2>General questions</h2><p>For product questions, feedback, billing, business inquiries, privacy questions, or other general matters:</p><a className="contact-email" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></div>
        <div className="contact-divider"/>
        <div><h2>Need technical help?</h2><p>For assistance using MySimpleDB Notes, account access, or technical issues, please visit Help &amp; Support or email:</p><a className="contact-email" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></div>
      </section>
      <section className="product-card contact-form-card">
        <h2>Start an email</h2><p>Choose a topic and add a short message. Your email program will open with the information filled in.</p>
        <label htmlFor="mysimpledbnotes-topic">Topic</label>
        <select id="mysimpledbnotes-topic" value={topic} onChange={e=>setTopic(e.target.value)}>
          <option>General Question</option><option>Billing</option><option>Feedback</option><option>Business Inquiry</option><option>Privacy</option><option>Other</option>
        </select>
        <label htmlFor="mysimpledbnotes-message">Message</label>
        <textarea id="mysimpledbnotes-message" rows="6" value={message} onChange={e=>setMessage(e.target.value)} placeholder="How can we help?"/>
        <button type="button" className="contact-button" onClick={handleEmail}>Email MySimpleDB Notes</button>
        <p className="security-note">Please do not send passwords, two-factor authentication codes, recovery keys, vault passphrases, or other sensitive account information by email.</p>
      </section>
    </main><Footer/>
  </div>;
}
